import { render, staticRenderFns } from "./HubPage.vue?vue&type=template&id=0acd5abc&scoped=true&"
import script from "./HubPage.vue?vue&type=script&lang=js&"
export * from "./HubPage.vue?vue&type=script&lang=js&"
import style0 from "./HubPage.vue?vue&type=style&index=0&id=0acd5abc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0acd5abc",
  null
  
)

export default component.exports